import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { Rest } from '../../../rest/rest_client';
import { UserService } from '../../../rest/user.service';
import { AuthenticationService } from '../../../core/services/authentication/authentication.service';
import { I18nService } from '../../../services/i18n/i18n.service';
import { NotificationsService, Severity } from '../../../services/notifications-service/notifications.service';
import { EntityFormComponent } from '../../entity-form/entity-form.component';
import { TranslateService } from "@ngx-translate/core";
import { RestExt } from "../../../services/rest-client-extension";
import MetricEnum = RestExt.MetricEnum;
import { IconService } from 'app/rest/icon.service';
import NotificationReceiver = Rest_task.NotificationReceiver;
import { RestExtTask } from '../../../modules/task/rest-client-task-extension';
import { Rest_task } from '../../../modules/task/administration/services/rest_client_task';

@Component({
    selector: 'app-user-advanced-settings',
    templateUrl: './user-advanced-settings.component.html',
    styleUrls: ['./user-advanced-settings.component.css'],
    providers: [ConfirmationService, IconService],
})
export class UserAdvancedSettingsComponent implements OnInit {
    @ViewChild('modal') modal: ElementRef;
    @ViewChild('profileForm') form;
    @ViewChild('closeUserProfileModalButton') closeModalButton: ElementRef;
    title = "Configuración Avanzada";
    display = false;
     receiverId = 0;
    tabActiveIndex = 0;
    NotificationReceiver = NotificationReceiver;
    customerNotificationReceiver: NotificationReceiver = NotificationReceiver.CUSTOMER
    @Output() openModal = new EventEmitter<void>();
    manageAnalysis: boolean;

    constructor(
        private userService: UserService,
        public notificationsService: NotificationsService,
        protected i18n: I18nService,
        private authenticationService: AuthenticationService,
        private translate: TranslateService,
        private iconService: IconService,
    ) {

    }
    ngOnInit() {

    }

  // Método para emitir el evento
    triggerModal() {
        this.openModal.emit();
    }

    public show(){
        this.display = true;
        this.manageAnalysis = RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_ANALYSIS_VIEW, this.authenticationService.user);
        if (this.manageAnalysis == false)
            this.manageAnalysis = RestExtTask.hasPermissionrp(RestExtTask.ActionTaskEnum.TASK_ATTRIBUTES_VIEW, this.authenticationService.user);
       
    }

     public hide(){
        this.display = false;
        this.triggerModal();
    }

}
